import React, {useEffect} from 'react';
import {createMuiTheme, makeStyles} from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import userService from "../../services/user";
import {ThemeProvider} from "@material-ui/styles";
const useStyles = makeStyles({
    root: {
        width: "95%",
        padding:"0 2.5%",
        position: "relative",
        top:2
    },
});
const muiTheme = createMuiTheme({
    overrides: {
        MuiSlider: {
            thumb: {
                color: "pink"
            },
            track: {
                background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
            },
            rail: {
                color: "black"
            }
        }
    }
});
export default function Scrubber(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState<number>(props.value);
    const [seeking, setSeeking] = React.useState<boolean>(false);

    const isScrubbingAllowed = () => {
        if (props.enableScrubbing) {
            return true;
        }
        if (!userService.currentUser?.is_admin && !userService.currentUser?.jessicas_room) {
            return false;
        }
        return true;
    }
    const [allowScrubbing, setScrubbing] = React.useState<boolean>(() => isScrubbingAllowed() )
    useEffect(() => {
        if(!seeking){
            setScrubbing(props.enableScrubbing);
        }
    }, [props.enableScrubbing]);
    useEffect(() => {
        if(!seeking){
            setValue(props.value);
        }
    }, [props.value]);
    const handleChange = (event: any, newValue: number | number[]) => {
        console.log("change");
        if(!seeking){
            //props.onChange(newValue);
        }
        setValue(newValue as number);
    };

    const handleChangeCommitted = (event: any, newValue: number | number[]) => {
        props.onChange(value);

    };

    const handleMouseDown = (event: any, newValue: number | number[]) => {
        console.log("down");

        setSeeking(true);
    };

    const handleMouseUp = (event: any, newValue: number | number[]) => {
        console.log("up");

        setSeeking(false);
    };

    return (
        <div className={classes.root}>
            <ThemeProvider theme={muiTheme}>
            <Slider value={value}
                    onChange={handleChange}
                    onChangeCommitted={handleChangeCommitted}
                    onMouseDown={handleMouseDown}
                    disabled={!allowScrubbing}
                    onMouseUp={handleMouseUp}
                    // getAriaValueText={()=>{return props.videoState.duration}}
                    // valueLabelDisplay="auto"
                    aria-labelledby="continuous-slider" />
            </ThemeProvider>
        </div>
    );
}
